import * as z from "zod";

const StartSfomOrderBacksyncInputSchema_ = z.object({
  teamId: z.string(),
  /** ISO 8601 instant to backsync from. */
  since: z.string(),
});

export const StartSfomOrderBacksyncInputSchema: z.ZodType<StartSfomOrderBacksyncInput> =
  StartSfomOrderBacksyncInputSchema_;
export interface StartSfomOrderBacksyncInput extends z.infer<
  typeof StartSfomOrderBacksyncInputSchema_
> {}

export const startSfomOrderBacksync = {
  name: "startSfomOrderBacksync" as const,
  input: StartSfomOrderBacksyncInputSchema,
  output: z.object({ workflowId: z.string() }),
};
